import FormProps from 'components/FormProps';
import AccessResource from 'models/access/resource';
import { Alert, Form, InputGroup } from 'react-bootstrap';
import React from 'react';

export type Props = FormProps<AccessResource>;

export const Delete = ({ value, disabled, error }: Props) => (
  <>
    <Form.Group className="form-group">
      <InputGroup>
        <InputGroup.Text>Navn</InputGroup.Text>
        <Form.Control name="company" disabled={disabled} value={value.company} isInvalid={error?.company !== undefined} />
      </InputGroup>
    </Form.Group>
    <Form.Group className="form-group">
      <InputGroup>
        <InputGroup.Text>Upload kode</InputGroup.Text>
        <Form.Control name="token" disabled={disabled} value={value.token} isInvalid={error?.token !== undefined} />
      </InputGroup>
    </Form.Group>
    <Alert variant="danger">
      Sletning af adgang sletter også de filer der er blevet uploadet med den!
    </Alert>
  </>
);
export default Delete;
